export const colors = {
  black: '#000',
  white: '#fff',
  text: '#000',
  primary: '#46a9b4',
  secondary: '#8861a9',
  ternary: '#c31622',
  gray: '#B9BDC0',
  primaryDark: '#006D73',
  secondaryDark: '#573A66',
  ternaryDark: '#A01314',
  grayDark: '#8B9196',
  primaryLight: '#DAEEF0', // B5DDE1
  secondaryLight: '#E7DFEE', // CFC0DD
  ternaryLight: '#F3D0D3', //E7A2A7
  greyLight: '#F3F1ED', //'#E8E9EA',
}

export enum Color {
  primary = 'primary',
  secondary = 'secondary',
  tertiary = 'tertiary',
  black = 'black',
  gray = 'gray',
  grayDark = 'grayDark',
}

export type ColorInText =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'black'
  | 'gray'
  | 'grayDark'
